<template>
    <div id="app">
        <div class="container h-100" v-if="!isLoading">
            <div class="row row-cols-1 align-items-center page-row">
                <div class="col col-cont">
                    <div class="row row-cols-1 justify-content-center row-cont">
                        <div class="col text-center">
                            <h1>{{ $t("countryChooser.welcome") }}</h1>
                            <p>{{ $t("countryChooser.yourWebshop") }}</p>
                        </div>
                        <chooser-with-icon :lang="lang"/>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isLoading" class="container h-100">
            <div class="row row-cols-1 align-items-center h-100 justify-content-center">
                <b-card class="col-sm-6 col-md-9 col-lg-2  text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
    import ChooserWithIcon from "./components/ChooserWithIcon";

    export default {
        data() {
            return {
                lang: 'en'
            };
        },
        components: {
            ChooserWithIcon,
        },
        computed: {
            isLoading: {
                get() {
                    return this.$store.getters["isLoading"];
                },
                set(value) {
                    this.$store.commit("setIsLoading", value);
                }
            }
        },
        watch: {
            isLoading(value) {
                if (value === false) {
                    document.title = this.$t("countryChooser.welcome");
                }
            }
        },
        created() {
            this.loadLang((lang) => {
                this.lang = lang;
            });
            document.title = this.$t("countryChooser.welcome");
        }
    }
</script>
<style lang="scss">

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        flex: 1 0 auto;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
    .country-chooser-card {
        min-height: 372px;
    }
    .country-chooser {
        max-width: 340px;
        margin: auto;
        font-size: 16px;
    }
    .col-cont {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
    .page-row {
        min-height: 85%;
    }
</style>
